/**
 * @generated SignedSource<<16d1e5c061b58a59b39e0db4a766a0c7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type topnavRightPanel_user$data = {
  readonly avatarFallback: string;
  readonly photo: {
    readonly signedUrl: string;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"profileUpdateDialog_user">;
  readonly " $fragmentType": "topnavRightPanel_user";
};
export type topnavRightPanel_user$key = {
  readonly " $data"?: topnavRightPanel_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"topnavRightPanel_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "topnavRightPanel_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ImageFile",
      "kind": "LinkedField",
      "name": "photo",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "signedUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "avatarFallback",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "profileUpdateDialog_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "f96d2d05c9a3014470663ddd3ce9316f";

export default node;
